import React, { useState, useContext } from 'react';
import Data from '../../data';

import AddCarrierHeader from '../AddCarrierHeader.component';
import { Section, SectionBody } from '../../ui/layout/Section.component';
import Footer from '../../ui/layout/Footer.component';
import Modal from '../../modal';
import Spinner from '../../ui/Spinner.component';
import Utils from '../../utils';
import CarrierUtils from '../Util';

const { ModalContext } = Modal;
const { Communication } = Utils;
const { Carrier } = Data;

const AddDhlxAccount = ({ completionCallback, custId = null, enterpriseLocations = null }) => {
	const [isLoading, setIsLoading] = useState(false);
	const { showError } = useContext(ModalContext);

	const onAcceptButtonClick = async () => {
		if (!enterpriseLocations) {
			const data = {
				Carrier: 'DHLExpress',
				UserOwnedAccount: false,
				CustId: custId,
				AgreeToEula: true,
			};

			setIsLoading(true);

			const response = data.CustId
				? await Communication.addCarrierToLocation(data)
				: await Communication.addCarrier(data);

			if (Communication.isSuccessful(response)) {
				completionCallback(true, Carrier.DHLExpress);
			} else {
				showError({ response });
				setIsLoading(false);
			}
		} else {
			const response = await Communication.addCarrierToLocations(
				CarrierUtils.createAddCarrierToLocationsRequest(enterpriseLocations, 'DHLExpress')
			);

			if (Communication.isSuccessful(response)) {
				completionCallback(true, Carrier.DHLExpress, enterpriseLocations.length);
			}
		}
	};

	const onCancelButtonClick = () => {
		completionCallback(false);
	};

	return (
		<div className="common-carrier-ups-eula">
			<Section>
				<AddCarrierHeader title="DHL Express International" carrier={Carrier.DHLExpress} />
				<SectionBody>
					<p>
						DHL Express is the premier international carrier with a reliably fast
						door-to-door delivery service to over 220 countries and territories. If
						you’re looking to increase your global reach and get your orders delivered
						as quickly as possible, choose DHL Express for your international shipping
						needs today.
					</p>
					<ul>
						<li>Delivery in 1–4 business days to most international locations</li>
						<li>Ideal for time-sensitive shipments</li>
						<li>Unparalleled customs expertise</li>
						<li>Online, real-time tracking</li>
					</ul>
					<p>Plus, sign up through Stamps.com and get these benefits:</p>
					<ul>
						<li>Up to 72% off DHL Express labels</li>
						<li>No contract or volume commitments</li>
						<li>Free courier pickup</li>
						<li>Free DHL packaging</li>
					</ul>
					<p>To ship with DHL Express, you must read and agree to the following:</p>
					<ul>
						<li>
							<a
								className="dhl-technology-agreement-link"
								href="https://mydhl.express.dhl/us/en/legal/terms-and-conditions.html"
								target="_blank"
								rel="noreferrer noopener"
							>
								DHL Express Terms & Conditions
							</a>
						</li>
					</ul>
				</SectionBody>
				<Footer
					primary={{
						label: 'Enable DHL Express',
						onClick: onAcceptButtonClick,
						disabled: isLoading,
						dataqa: 'add-dhl-account-enable',
					}}
					secondary={{
						label: enterpriseLocations ? 'Start Over' : 'Cancel',
						onClick: onCancelButtonClick,
						dataqa: `add-dhl-account-${enterpriseLocations ? 'start-over' : 'cancel'}`,
					}}
				/>
				{isLoading && <Spinner msg="Connecting DHL Express Account..." />}
			</Section>
		</div>
	);
};

export default AddDhlxAccount;
